/**
 * Central enum → label translation layer (DE / EN / HR) — Welle 3.
 *
 * Final DealFlow Product Logic (2026-07): the UI must NEVER render a
 * raw backend enum (`semi_detached_house`, `station_wagon`, …). Every
 * surface pipes enum values through `enumLabel(kind, value)`.
 *
 * ALL label maps live in the shared `enums` locale namespace
 * (i18n/locales/<lang>/enums.json) — the SAME files the mobile app
 * consumes (synced via scripts/sync-locales.js). Fallback chain:
 * current locale → DE → prettified raw (Title Case, no snake_case).
 */
import i18n from "../i18n";

function prettify(raw) {
  return raw
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function enumLabel(kind, value) {
  if (!value) return "";
  const key = String(value).toLowerCase().trim();
  const k = `enums:${kind}.${key}`;
  if (i18n.exists(k)) return i18n.t(k);
  return prettify(key);
}

/** Feature slug → localized chip label ("Highlights" rows). */
export function featureLabel(slug) {
  return enumLabel("features", slug);
}
